import { type ServiceMethod } from '@/application/interfaces/service';
import { type ErrorResponse as BaseErrorResponse } from '@/infra/services/model';

export type Params = {
  cartId: string;
};

interface BaseCreditCard {
  amount_installment: number;
  bin_suffix: string;
  brand: string;
  token: string;
  security_code: string;
}

interface SavedCreditCard extends BaseCreditCard {
  type: 'token';
  external_id: string;
}

interface CreditCard extends BaseCreditCard {
  type: 'credit_card';
  valid_until: string;
  owner_card_name: string;
  bin_prefix: string;
  save_card?: string;
}

export type Body = {
  payment_method: 'credit_card' | 'pix' | 'bank_slip';
  credit_card?: CreditCard | SavedCreditCard;
  value: number;
  vouchers: string[];
  fingerprint_session_id: string;
};

export type ErrorResponse = BaseErrorResponse<
  'payment_value' | 'check-credit-card'
>;
export type Data = Params & Body;

export type Response = {
  data: {
    id: string;
  };
};

const postPayment: ServiceMethod<Response, Data> =
  (httpClient) => async (data, options) => {
    const {
      cartId,
      payment_method,
      credit_card,
      value,
      vouchers,
      fingerprint_session_id,
    } = data;

    const { body: response } = await httpClient.post<Response, Body, Params>(
      '/api/v3/payment/{cartId}',
      {
        ...options,
        body: {
          payment_method,
          credit_card,
          value,
          vouchers,
          fingerprint_session_id,
        },
        params: {
          cartId,
        },
        trackingData: {
          payment_method,
          value,
          vouchers,
        },
      }
    );

    return response;
  };

export default postPayment;
